import PaymentBankAccountQuery from "../../domain/core/payments/PaymentBankAccountQuery";
import { PaymentBankAccountModel } from "../../domain/models/PaymentBankAccount";
import { IQueryPaymentBankAccountRepository } from "../../domain/ports/payments/IQueryPaymentBankAccountRepository";
import QueryService from "../QueryService";

export class PaymentBankAccountQueryService
  extends QueryService<PaymentBankAccountModel>
  implements IQueryPaymentBankAccountRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const paymentBankAccountQuery = new PaymentBankAccountQuery(
  new PaymentBankAccountQueryService(BASE_URL, "payment_bank_accounts"),
);

export { paymentBankAccountQuery };
